import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';

import { commonUtils } from '../../common/index.js';
import { getQueryClass } from '../queryUtils/getQueryClass.js';

import { BaseTransform } from './BaseTransform.js';

export class NumberTransform extends BaseTransform {
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions): any {
		if (queryResponse && commonUtils.isNumber(+queryResponse)) {
			const { numberOptions } = this.options;
			if (numberOptions && numberOptions.operator) {
				let value = numberOptions.value;
				if (numberOptions.valueQuery) {
					const valueQuery = getQueryClass(this.dependencies, numberOptions.valueQuery, this.translationHelper)
					if (valueQuery) {
						value = valueQuery.execute(executionOptions);
					}
				}
				try {
					let response;
					switch (numberOptions.operator) {
						case 'multiply':
							response = queryResponse * value;
							break;
						case 'divide':
							response = queryResponse / value;
							break;
						case 'add':
							response = queryResponse + value;
							break;
						case 'subtract':
							response = queryResponse - value;
							break;
						case 'modulus':
							response = queryResponse % value;
							break;
						default:
							response = queryResponse;
					}
					if (numberOptions.roundingOptions) {
						let decimalMultiplier = 1;
						if (numberOptions.roundingOptions.decimalPlaces) {
							decimalMultiplier = Math.pow(10, numberOptions.roundingOptions.decimalPlaces);
						}
						switch (numberOptions.roundingOptions.type) {
							case 'standard':
								return Math.round(response * decimalMultiplier) / decimalMultiplier;
							case 'ceiling':
								return Math.ceil(response * decimalMultiplier) / decimalMultiplier;
							case 'floor':
								return Math.floor(response * decimalMultiplier) / decimalMultiplier;
							default:
								return response;
						}
					}
					return response;
				} catch (ex) {
					console.warn(
						`Error while performing NumberTransform, queryResponse: ${queryResponse}, operator: ${numberOptions.operator}, value: ${value}, error: `,
						ex,
					);
				}
			}
		}
		return queryResponse;
	}
}
